<template>
  <!-- 通勤精算一覧 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>通勤費精算(仮払申請)一覧</h2>
      </CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th style="width: 240px">絞り込み</th>
            <th></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select preika-control--year"
                v-model="year"
               
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select preika-control--month"
                v-model="month"
               
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>
            <td>
              <!-- 年月と同じ検索行に置く。検索ボタンは1つのまま、まとめて送る。 -->
              <input
                v-model="keyword"
                type="text"
                class="form-control"
                maxlength="100"
                placeholder="社員番号・氏名・所属で絞り込む"
                @keyup.enter="search"
              />
            </td>
            <td>
              <button class="btn btn-primary" @click="search">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <!-- <CCardHeader><strong>詳細入力</strong></CCardHeader> -->
        <CCardBody>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" width="100px">社員名</th>
                  <th scope="col" width="80px">ステータス</th>
                  <th scope="col" width="100px">承認者</th>
                  <th scope="col" width="100px">承認日</th>
                  <th scope="col">差戻し理由</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td nowrap>
                    <router-link
                      :to="{
                        name: travelCostMasterInfo,
                        params: {
                          user_id: item.user_id,
                          year: year,
                          month: month,
                        },
                      }"
                      >{{ item.user_name }}</router-link
                    >
                  </td>
                  <td :style="statusColor(item.status)" nowrap>{{ item.status }}</td>
                  <td>{{ item.approver }}</td>
                  <td>{{ item.approval_date }}</td>
                  <td class="linefeed">{{ item.comment }}</td>
                  <td white-space: nowrap>
                    <button class="btn btn-info" @click="openPDF(item.user_id)">
                      PDF
                    </button>
                    <save-button
                      v-show="item.status === '承認済み'"
                      :label="'承認取消'"
                      :loading="loading"
                      class="btn btn-danger"
                      @click="revocationOfApproval(item.user_id, item.user_name,item.document_type,item.approver_user_id,item.comment,item.submissionId)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <!-- ページング処理 -->
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-page="currentPage"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>

<script>
import SaveButton from "../../common/SaveButton";
import ConstList from "./../../ConstList";
import axios from "axios";
import moment from "moment";
import VPagination from "vuejs-paginate";
export default {
  name: "MonthlyReport",
  components: {
    SaveButton,
    VPagination,
  },
  data() {
    return {
      year: "",
      month: "",
      keyword: "",
      date: "",
      items: [],
      callFlg: false,
      travelCostMasterInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      loading: false,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.travelCostMasterInfo = ConstList.ROUTE_TRAVEL_COST_MASTER_INFO;
  },

  methods: {
    // 検索ボタンとEnterから呼ぶ。
    // 絞り込むと結果が減るので、5ページ目のままだと空の表になる。必ず1ページ目へ戻す。
    search: function () {
      this.currentPage = 1;
      this.callList();
    },
    callList: function () {
      this.callFlg = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/commute/list", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            // 空文字は送らない。送るとサーバ側が「空で絞り込む」形になりうる。
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          this.callFlg = true;
          this.items = response.data;
          // sessionStorageへ保存
          sessionStorage.setItem(
            "travelcostList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "travelcostList-search-params",
            JSON.stringify({
              year: this.year,
              month: this.month,
              keyword: this.keyword,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/commute/count", {
          params: {
            year: this.year,
            month: this.month,
            // 一覧と同じ絞り込みで数える。片方だけだとページ数がずれる。
            keyword: this.keyword || undefined,
          },
        })
        .then((response) => {
          const totalCount = response.data;
          // **ページ数は最低1。**Math.ceil(0 / 10) は 0 で、0件のときに
          // ページャそのものが消えてしまう。
          this.totalPages = Math.max(1, Math.ceil(totalCount / this.pageSize));
          // 数え直したあとに、見ているページを 1〜totalPages へ収める。
          // 覚えていたページへ戻ったとき、そのあいだに件数が減っていると
          // 空の表になるので、収めた側で引き直す。
          const inRange = Math.min(Math.max(1, this.currentPage), this.totalPages);
          if (inRange !== this.currentPage) {
            this.currentPage = inRange;
            this.callList();
          }
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },
    // 承認取消メソッド
    revocationOfApproval: function (user_id, user_name,document_type,approver_user_id,comment,id) {
      if (
        confirm(
          user_name +
            "さんの" +
            this.year +
            "年" +
            this.month +
            "月" +
            "「通勤費精算」承認を取り消してもよろしいですか？"
        )
      ) {
        this.loading = true;
        this.sendList = [];
        const selectItem = {
          user_id: user_id,
          year: this.year,
          month: this.month,
          id: id,
          approver_user_id:
          approver_user_id === null ? user_id : approver_user_id,
          comment: comment,
          document_type: document_type,
        sns_message: this.sns_message,
        };
        this.sendList.push(selectItem);
        // 非同期処理
        axios
          .post(
            process.env.VUE_APP_API_ORIGIN + "/submission/revocation_of_approval",
            this.sendList
          )
          .then(() => {
            alert("承認を取り消しました");
            window.location.reload();
            this.callList();
          })
          .catch((error) => {
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    //PDF出力メソッド
    openPDF: function (user_id) {
      const params = new URLSearchParams();
      params.append("user_id", user_id);
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/commute/pdf", {
          params: params,
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank");
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },

    setBlue: function (bluenum, index) {
      if (this.blue[index][bluenum] === "blue") {
        this.blue[index].splice(bluenum, 1, "");
      } else {
        this.blue[index].splice(bluenum, 1, "blue");
      }
    },
    setYellow: function (yellownum, index) {
      if (this.yellow[index][yellownum] === "yellow") {
        this.yellow[index].splice(yellownum, 1, "");
      } else {
        this.yellow[index].splice(yellownum, 1, "yellow");
      }
    },

    groupBy: function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
  },
  mounted: function () {
    // 前回の検索パラメータがあれば取得。
    //
    // **確かめる鍵と、読む鍵を同じにする。**別の鍵（-items）の有無で
    // 判定して -params を読むと、片方だけ残っているときに
    // JSON.parse(null) で落ちる。
    const saved = sessionStorage.getItem("travelcostList-search-params");
    if (saved) {
      //this.callFlg = true;
      //this.items = JSON.parse(
      //  sessionStorage.getItem("travelcostList-search-items")
      //);
      const params = JSON.parse(saved);
      this.year = params.year;
      this.month = params.month;
      // 絞り込みも年月と同じように戻す。保存前の古い内容だと無いので空にする。
      this.keyword = params.keyword || "";
      // **見ていたページへ戻す。**保存しているのだから復元する。
      // 件数が減っていることがあるので、数え直したあと
      // （fetchTotalPages）に 1〜totalPages へ収める。
      this.currentPage = Number(params.currentPage) || 1;
      this.callList();
      this.callFlg = true;
      //this.pageSize = params.pageSize;
      //this.totalPages = params.totalPages;
    } else {
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");

    }
  },
};
</script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    
    <style scoped>
td,
th {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
